
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill indigo-200",attrs:{"d":"M16 11a4 4 0 11-8 0 4 4 0 018 0z"}}),_c('path',{staticClass:"fill indigo-800",attrs:{"d":"M20 22a1 1 0 102 0h-2zM2 22a1 1 0 102 0H2zM4.719 5.709l.808.588-.808-.588zm14.562 0l-.808.588.808-.588zm1.7-3.775a1 1 0 10-1.995.132l1.995-.132zm-15.967.132a1 1 0 10-1.995-.132l1.995.132zm3.431 16.103a1 1 0 10-.89 1.791l.89-1.791zm8 1.791a1 1 0 10-.89-1.791l.89 1.791zM20 11v11h2V11h-2zM4 22V11H2v11h2zM5.623 5.28A6.47 6.47 0 015 2.5H3c0 1.3.292 2.533.815 3.637l1.808-.857zM4 11a7.96 7.96 0 011.527-4.703L3.911 5.12A9.96 9.96 0 002 11h2zm1.527-4.703A7.988 7.988 0 0112 3V1a9.988 9.988 0 00-8.09 4.12l1.617 1.177zM19 2.5a6.47 6.47 0 01-.623 2.78l1.808.857A8.471 8.471 0 0021 2.5h-2zM12 3a7.988 7.988 0 016.473 3.297l1.616-1.177A9.988 9.988 0 0012 1v2zm6.473 3.297A7.96 7.96 0 0120 11h2a9.96 9.96 0 00-1.91-5.88l-1.617 1.177zm.513-4.231c.01.143.014.288.014.434h2c0-.19-.006-.379-.019-.566l-1.995.132zM5 2.5c0-.146.005-.29.014-.434L3.02 1.934A8.616 8.616 0 003 2.5h2zM15 11a3 3 0 01-3 3v2a5 5 0 005-5h-2zm-3 3a3 3 0 01-3-3H7a5 5 0 005 5v-2zm-3-3a3 3 0 013-3V6a5 5 0 00-5 5h2zm3-3a3 3 0 013 3h2a5 5 0 00-5-5v2zm0 11c-1.279 0-2.485-.3-3.555-.831l-.89 1.791A9.963 9.963 0 0012 21v-2zm3.555-.831A7.964 7.964 0 0112 19v2a9.963 9.963 0 004.445-1.04l-.89-1.791zM14 13v2a2 2 0 002-2h-2zm0 0h-2a2 2 0 002 2v-2zm0 0v-2a2 2 0 00-2 2h2zm0 0h2a2 2 0 00-2-2v2z"}})])
          )
        }
      }
    